/// <amd-module name="Build/SourceProviders/Common" />
import { Change, SourceRelatedWorkItem } from "Build/Client/Contracts/Build";

import { TfvcShelvesetRef } from "VC/Common/Contracts/Git";

export namespace RepositoryTypes {
    export const TfsVersionControl = "TfsVersionControl".toLowerCase();
    export const TfsGit = "TfsGit".toLowerCase();
    export const ExternalUnknown = "ExternalUnknown".toLowerCase();
    export const ExternalGit = "Git".toLowerCase();
    export const GitHub = "GitHub".toLowerCase();
    export const GitHubEnterprise = "GitHubEnterprise".toLowerCase();
    export const Bitbucket = "Bitbucket".toLowerCase();
    export const Svn = "Svn".toLowerCase();
}

export interface IProjectInfo {
    id: string;
    name: string;
}

export interface IBranchInfo {
    branchName: string;
    repositoryName?: string;
    repositoryUrl?: string;
    links?: { [key: string]: any };
}

export interface ILinkInfo {
    branchName: string;
    repositoryName: string;
    commitId: string;
    displayUri: string;
    projectName?: string;
    repositoryUrl?: string;
    links?: { [key: string]: any };
}

export interface ICommitInfo {
    repositoryName: string;
    commitId: string;
    displayUri: string;
}

export interface ICommitDiffInfo {
    repositoryName: string;
    baseCommitId: string;
    targetCommitId: string;
    displayUri: string;
}

export interface IRepositoryInfo {
    repositoryName: string;
    repositoryUrl?: string;
    repositoryId?: string;
}

export interface IContentInfo {
    id: string;
    repositoryName: string;
    lineNumber: string;
    lineTooltip: string;
    version: string;
    path: string;
    isError?: boolean;
}

export interface IPullrequestInfo {
    branchName: string;
    repositoryName: string;
    projectId: string;
    serviceEndpointId?: string;
    pullRequestNumber?: string;
}

export interface ILinkData {
    originalId: string;
    commitId: string;
    commitLink: string;
    branchLink: string;
    repositoryLink: string;
    projectName?: string;
}

export interface IPullrequestData {
    id: number;
    title: string;
    sourceRepositoryOwner: string;
    sourceBranch: string;
    targetRepositoryOwner: string;
    targetBranch: string;
    rawSourceBranch: string;
    rawTargetBranch: string;
    url: string;
}

export interface IContentLinkData {
    id: string;
    link: string;
}

// Make sure routes used here are added to _sharedRoutes
export interface ISourceProvider {
    getKey(): string;
    getName(): string;

    getMaxWorkItems(): number | undefined;
    getRepoIconName(): string;
    fetchBranchLink(info: IBranchInfo, projectName?: string): Promise<string | null>;
    getBranchText(branch: string): string;
    getBranchIconName(branch: string): string;
    getNormalizedBranch(branch: string, projectInfo: IProjectInfo): string;
    getNormalizedCommit(commit: string): string;
    getProjectName(repositoryId: string): Promise<string | null>;

    fetchPRCommitLink(info: IBranchInfo, projectName?: string): Promise<string | null>;
    fetchCommitLink(info: ICommitInfo, projectName?: string): Promise<string | null>;
    fetchCommitDiffLink(info: ICommitDiffInfo, projectName?: string): Promise<string | null>;
    getCommitText(commit: string): string;
    getCommitIconName(): string;

    fetchRepositoryLink(info: IRepositoryInfo, projectName?: string): Promise<string | null>;

    fetchLinks(info: ILinkInfo[]): Promise<ILinkData[] | null>;

    fetchContentLink(info: IContentInfo): Promise<string | null>;

    fetchContentLinks(info: IContentInfo[]): Promise<IContentLinkData[] | null>;

    fetchPullrequestData(info: IPullrequestInfo): Promise<IPullrequestData | null>;

    fetchShelvesets(owner: string): Promise<TfvcShelvesetRef[]>;
}
